import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { Apresentacao } from "../models/apresentacao.model";

@Injectable()
export class ApresentacaoService extends BaseService<Apresentacao> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getListCombos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list', { headers: this.headers });
  }

  public getGraphData(id:number,type: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/graph/' + id + '/' + type, { headers: this.headers });
  }

  public getDemandsData(id:number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/demands/' + id, { headers: this.headers });
  }
  public getReportHistoryData(id:number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/report-history/' + id, { headers: this.headers });
  }

  public createDemand(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/demand', obj, { headers: this.headers });
  }


  public downloadFile(doc_id: number, type:string): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + doc_id + '/' + type, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }

  public getThumbnails(indicator_id: number): Observable<any> {
    return this.http.get(this.baseUrl + "/thumbnails/" + indicator_id, { headers: this.headers });
  }

  public saveNotes(obj: any, meeting_id: number): Observable<any> {
    
    return this.http.post(this.baseUrl + "/notes/" + meeting_id, obj,{ headers: this.headers });
  }
  
  public sendNotesMail(meeting_id: number): Observable<any> {
    return this.http.post(this.baseUrl + "/send-notes-mail/" + meeting_id, { headers: this.headers });
  }
  
  public saveReport(meeting_id: number, formData: FormData): Observable<any> {
    return this.http.post(this.baseUrl + "/save-report/" + meeting_id, formData);
  }
  
  public getPathModule(): string {
    return '/reuniao/apresentacao';
  }
}